import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { alertActions, pricingDrawerUiActions } from '@actions';
import { BILLING_TYPE_MAP } from '@constants/billing';
import { getActiveSubscriptions, getEntitledSubscriptions } from '@helpers/billing';
import { PRICING_DRAWER_TYPE } from '@constants/pricing-drawer-ui';
import { RoutePath } from '@constants/routes';
import usePermissions from './usePermissions';
import { useTranslation } from './useTranslation';

// Non-admins get a toast (drawer requires billing permission). Multi-Stripe accounts
// route to Account Settings (drawer only handles a single subscription).
export const useOpenUpgradeDrawer = () => {
    const account = useSelector(state => state.account?.account);
    const { hasFullSettings } = usePermissions();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return ({
        type = PRICING_DRAWER_TYPE.UPGRADE,
        defaultPlan = BILLING_TYPE_MAP.PROFESSIONAL,
        titleKey = null,
        subtitleKey = null,
        directoriesLocation = null,
    } = {}) => {
        if (!hasFullSettings()) {
            dispatch(alertActions.error(t('common.upgradeAskAdmin')));
            return;
        }
        const entitled = getEntitledSubscriptions(account);
        if (entitled.length > 1) {
            navigate(RoutePath.AccountSettingsBilling);
            dispatch(alertActions.error(t('common.upgradeToAdd')));
            return;
        }
        if (entitled.length > 0 && getActiveSubscriptions(account).length === 0) {
            navigate(RoutePath.AccountSettingsBilling);
            dispatch(alertActions.error(t('common.planCancelledUntilPeriodEnd')));
            return;
        }
        dispatch(
            pricingDrawerUiActions.setOpen({
                open: true,
                type,
                defaultPlan,
                titleKey,
                subtitleKey,
                directoriesLocation,
            }),
        );
    };
};
